import type { GridColumnHeaderParams, GridRenderCellParams } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import type { SearchColumnDef } from '@/components/custom/arito';
import { Checkbox } from '@/components/ui/checkbox';

interface CheckboxColumnHeaderProps {
  currentPageRows: any[];
  onCellValueChange: (rowData: any, field: string, newValue: any) => void;
  resetKey: string;
}

const CheckboxColumnHeader = ({ currentPageRows, onCellValueChange, resetKey }: CheckboxColumnHeaderProps) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(false);
  }, [resetKey]);

  return (
    <Checkbox
      checked={checked}
      onCheckedChange={newValue => {
        const shouldSelect = newValue === true;
        setChecked(shouldSelect);

        currentPageRows.forEach(rowData => {
          onCellValueChange(rowData, 'selected', shouldSelect);
        });
      }}
    />
  );
};

export const checkboxColumn = (
  onCellValueChange: (rowData: any, field: string, newValue: any) => void = () => {},
  selectedInvoices: any[] = [],
  matchedField: string = 'uuid'
): SearchColumnDef[] => [
  {
    field: '',
    headerName: '',
    width: 50,
    type: 'boolean',
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderHeader(params: GridColumnHeaderParams) {
      const currentPageRows = ((params.colDef as any).currentPageRows || []) as any[];
      const resetKey = String((params.colDef as any).pageSelectionResetKey || '');

      return (
        <CheckboxColumnHeader
          currentPageRows={currentPageRows}
          onCellValueChange={onCellValueChange}
          resetKey={resetKey}
        />
      );
    },
    renderCell: (params: GridRenderCellParams) => {
      const fieldCheck = params.row[matchedField];
      const isChecked =
        Array.isArray(selectedInvoices) &&
        selectedInvoices.some(
          invoice => (typeof invoice === 'string' ? invoice : invoice[matchedField]) === fieldCheck
        );

      return (
        <Checkbox
          checked={isChecked}
          onCheckedChange={newValue => {
            onCellValueChange(params.row, 'selected', newValue);
          }}
        />
      );
    }
  }
];
